import { Icon } from '@/icons'
import classNames from 'classnames'
import { useCallback } from 'react'
import styles from './Word.module.scss'

type WordProps<TId> = {
  id: TId
  name: string
  onClick?: (id: TId) => void
  isDeletable?: boolean
  isReadonly?: boolean
  isSelected?: boolean
  className?: string
  isNice?: boolean
  maxWidth?: number | 'auto'
}
export const Word = <TId,>({
  id,
  name,
  onClick,
  isDeletable = false,
  isReadonly = false,
  isSelected = false,
  isNice = false,
  maxWidth,
  className,
}: WordProps<TId>) => {
  const click = useCallback(() => {
    if (onClick != null) {
      onClick(id)
    }
  }, [id, onClick])

  return !isReadonly ? (
    <button
      type="button"
      onClick={click}
      title={maxWidth != null ? name : undefined}
      style={{
        maxWidth:
          maxWidth != null
            ? maxWidth === 'auto'
              ? maxWidth
              : maxWidth + 'px'
            : undefined,
      }}
      className={classNames(className, {
        [styles.word]: true,
        [styles.isSelected]: isSelected,
        [styles.isDeletable]: isDeletable,
        [styles.withLimitedWidth]: maxWidth != null,
        [styles.withNice]: isNice,
        [styles.isReadonly]: isReadonly,
      })}
    >
      {name}
      {isNice ? <span className={styles.nice}>N</span> : null}
      {isDeletable ? <Icon className={styles.deleteIcon} name="close" /> : null}
    </button>
  ) : (
    <div
      title={maxWidth != null ? name : undefined}
      style={{
        maxWidth:
          maxWidth != null
            ? maxWidth === 'auto'
              ? maxWidth
              : maxWidth + 'px'
            : undefined,
      }}
      className={classNames(className, {
        [styles.word]: true,
        [styles.isSelected]: isSelected,
        [styles.withLimitedWidth]: maxWidth != null,
        [styles.withNice]: isNice,
        [styles.isReadonly]: isReadonly,
      })}
    >
      {name}
      {isNice ? <span className={styles.nice}>N</span> : null}
      {isDeletable ? (
        <Icon
          className={styles.deleteIcon}
          name="close"
          stroke="#0062ca"
          width="14"
        />
      ) : null}
    </div>
  )
}
